module.exports = __webpack_public_path__ + "static/media/100.c07aaebe.svg";